export const ANSWER_POLL = 'answer_poll';
export const COMPLETE_QUEST = 'complete_quest';
export const ENGAGE_OVERLAY = 'engage_overlay';
export const TIME_ON_SITE = 'time_on_site';
